<!--
<template>
  <div id="app">
    <div id="app_C">
      <el-input class="seek moveSeek"
                placeholder="请输入内容"
                suffix-icon="el-icon-search"
                @focus="focusEvent"
                @blur="blurEvent"
                v-model="state4">
      </el-input>
      <header class="wrapper">
        <el-row>
          <img src="../static/img/logo.png" alt="星辰热能Logo" class="logo">
          <el-menu id="el-menu1" :default-active="$route.path" class="el-menu-demo wrapper" mode="horizontal"
                   @select="handleSelect1">
            <el-menu-item index="/Home">
              <router-link to="/Home">&#12288;首页&#12288;</router-link>
            </el-menu-item>
            <el-menu-item index="/about" md="0">
              <router-link to="/about">关于星辰</router-link>
              <div class="vice">
                <ul>
                  <li>
                    <router-link to="/intro">公司简介</router-link>
                  </li>
                  <li>
                    <router-link to="/notice">公司公告</router-link>
                  </li>
                  <li>
                    <router-link to="/framework">组织架构</router-link>
                  </li>
                  <li>
                    <router-link to="/course">发展历程</router-link>
                  </li>
                  <li>
                    <router-link to="/honor">荣誉资质</router-link>
                  </li>
                  <li>
                    <router-link to="/culture">企业文化</router-link>
                  </li>
                </ul>
              </div>
            </el-menu-item>
            <el-menu-item index="/Product" md="1">
              <router-link to="/Product" @click.native="getName('全部')">产品中心</router-link>
              <div class="vice">
                <ul>
                  <li>
                    <router-link to="/Product" @click.native="getName('采暖专用机')">采暖专用机</router-link>
                  </li>
                  <li>
                    <router-link to="/Product" @click.native="getName('空气源热泵')">空气源热泵</router-link>
                  </li>
                  <li>
                    <router-link to="/Product" @click.native="getName('商用中央空调')">商用中央空调</router-link>
                  </li>
                  <li>
                    <router-link to="/Product" @click.native="getName('直饮水设备')">直饮水设备</router-link>
                  </li>
                  <li>
                    <router-link to="/Product" @click.native="getName('智能控制设备')">智能控制设备</router-link>
                  </li>
                </ul>
              </div>
            </el-menu-item>
            <el-menu-item index="/ProjectCase" md="2">
              <router-link to="/ProjectCase" @click.native="getName('')">项目案例</router-link>
              <div class="vice">
                <ul v-for="(item,index) in tradeList">
                  <li>
                    <router-link to="/ProjectCase" @click.native="getName(item.name)">{{item.name}}</router-link>
                  </li>
                </ul>
              </div>
            </el-menu-item>
            <el-menu-item index="/newsList" md="3">
              <router-link to="/newsList" @click.native="getName('1')">新闻资讯</router-link>
              <div class="vice">
                <ul>
                  <li>
                    <router-link to="/newsList" @click.native="getName('1')">公司新闻</router-link>
                  </li>
                  <li>
                    <router-link to="/newsList" @click.native="getName('2')">行业新闻</router-link>
                  </li>
                </ul>
              </div>
            </el-menu-item>
            <el-menu-item index="/domain" md="4">
              <router-link to="/domain">服务领域</router-link>
              <div class="vice">
                <ul>
                  <li>
                    <router-link to="/domain/airConditioner">空调系统</router-link>
                  </li>
                  <li>
                    <router-link to="/domain/illumination">照明系统</router-link>
                  </li>
                  <li>
                    <router-link to="/domain/heating">采暖系统</router-link>
                  </li>
                  <li>
                    <router-link to="/domain/hotWater">热水系统</router-link>
                  </li>
                  <li>
                    <router-link to="/domain/refrigerant">生态冷媒</router-link>
                  </li>
                  <li>
                    <router-link to="/domain/photovoltaic">光伏系统</router-link>
                  </li>
                  <li>
                    <router-link to="/domain/EMC">EMC节能</router-link>
                  </li>
                  <li>
                    <router-link to="/domain/terrace">智慧能源管理系统</router-link>
                  </li>
                </ul>
              </div>
            </el-menu-item>
            <el-menu-item index="/sustain" md="5">
              <router-link to="/sustain">服务支持</router-link>
              <div class="vice">
                <ul>
                  <li>
                    <router-link to="/sustain/leaveWord">客户留言</router-link>
                  </li>
                  <li>
                    <router-link to="/sustain/repairs">在线报修</router-link>
                  </li>
                  <li>
                    <router-link to="/sustain/contact">联系我们</router-link>
                  </li>
                  <li>
                    <router-link to="/sustain/partner">合作伙伴</router-link>
                  </li>
                </ul>
              </div>
            </el-menu-item>
            <el-input class="seek"
                      placeholder="请输入内容"
                      suffix-icon="el-icon-search"
                      @focus="focusEvent"
                      @blur="blurEvent"
                      v-model="state4">
            </el-input>
          </el-menu>
          <div id="nav">
            <p><span></span> <span></span> <span></span></p>
            <div class="phoneNav">
              <ul class="navList">
                <li class="lis">
                  <router-link to="/Home" @click.native='restore'>首页</router-link>
                </li>
                <li class="lis"><a href="#">关于星辰></a>
                  <div class="navListIn">
                    <ul>
                      <li>
                        <router-link @click.native='restore' to="/intro">公司简介</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/notice">公司公告</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/framework">组织架构</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/course">发展历程</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/honor">荣誉资质</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/culture">企业文化</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="lis"><a href="#">产品中心></a>
                  <div class="navListIn">
                    <ul>
                      <li>
                        <router-link to="/Product" @click.native="getName('采暖专用机');restore()">采暖专用机</router-link>
                      </li>
                      <li>
                        <router-link to="/Product" @click.native="getName('空气源热泵');restore()">空气源热泵</router-link>
                      </li>
                      <li>
                        <router-link to="/Product" @click.native="getName('商用中央空调');restore()">商用中央空调</router-link>
                      </li>
                      <li>
                        <router-link to="/Product" @click.native="getName('直饮水设备');restore()">直饮水设备</router-link>
                      </li>
                      <li>
                        <router-link to="/Product" @click.native="getName('智能控制设备');restore()">智能控制设备</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="lis"><a href="#">项目案例></a>
                  <div class="navListIn">
                    <ul v-for="(item,index) in tradeList">
                      <li>
                        <router-link @click.native="getName(item.name);restore()" to="/ProjectCase">{{item.name}}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="lis"><a href="#">新闻资讯></a>
                  <div class="navListIn">
                    <ul>
                      <li>
                        <router-link to="/newsList" @click.native="getName('1');restore()">公司新闻</router-link>
                      </li>
                      <li>
                        <router-link to="/newsList" @click.native="getName('2');restore()">行业新闻</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="lis"><a href="#">服务领域></a>
                  <div class="navListIn">
                    <ul>
                      <li>
                        <router-link @click.native='restore' to="/domain/airConditioner">空调系统</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/domain/illumination">照明系统</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/domain/heating">采暖系统</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/domain/hotWater">热水系统</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/domain/refrigerant">生态冷媒</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/domain/photovoltaic">光伏系统</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/domain/EMC">EMC节能</router-link>
                      </li>
                      <li>
                        <router-link @click.native='restore' to="/domain/terrace">智慧能源管理系统</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="lis"><a href="#">服务支持></a>
                  <div class="navListIn">
                    <ul>
                      <li>
                        <router-link to="/sustain/leaveWord" @click.native='restore'>客户留言</router-link>
                      </li>
                      <li>
                        <router-link to="/sustain/repairs" @click.native='restore'>在线保修</router-link>
                      </li>
                      <li>
                        <router-link to="/sustain/contact" @click.native='restore'>联系我们</router-link>
                      </li>
                      <li>
                        <router-link to="/sustain/partner" @click.native='restore'>合作伙伴</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>

            </div>
          </div>
        </el-row>

      </header>
      <router-view/>
      <footer class="footer">
        <div class="wrapper">
          <el-row type="flex" class="row-bg footer_top" justify="space-between">
            <el-col :xs="24" :sm="10" :md="5" :lg="5" :xl="5" class="item">
              <h2>产品中心</h2>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <router-link to="/Product" @click.native="getName('商用中央空调')">商用中央空调</router-link>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <router-link to="/Product" @click.native="getName('空气源热泵')">空气源热泵</router-link>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <router-link to="/Product" @click.native="getName('智能控制设备')">智能控制设备</router-link>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <router-link to="/Product" @click.native="getName('直饮水设备')">直饮水设备</router-link>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <router-link to="/Product" @click.native="getName('采暖专用机')">采暖专用机</router-link>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <router-link to="#">光伏发电</router-link>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <router-link to="#">智能照明</router-link>
                </el-col>
              </el-col>
            </el-col>
            <el-col :xs="24" :sm="10" :md="4" :lg="4" :xl="4" class="item">
              <h2>关于星辰</h2>
              <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/intro">公司简介</router-link>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/notice">公司公告</router-link>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/course">发展历程</router-link>
                </el-col>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/honor">荣誉资质</router-link>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/culture">企业文化</router-link>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/framework">组织架构</router-link>
                </el-col>
              </el-col>
            </el-col>
            <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="2" class="item">
              <h2>服务支持</h2>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/sustain/leaveWord">客户留言</router-link>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/sustain/repairs">在线保修</router-link>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <router-link to="/sustain/contact">联系我们</router-link>
                </el-col>
              </el-col>
            </el-col>
            <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="item">
              <h2>联系我们</h2>
              <el-row>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <span
                    style="display: inline-block;position: relative;top: 2px;width: 20px;height: 20px;background: url('../static/img/QQ.png')"></span>
                  1046620654
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"><i class="el-icon-message"></i>
                  gdxingchen@126.com
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"><i class="el-icon-location-outline"></i>
                  广州市海珠区广州大道南788号广一电商园2号楼3层
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"><i class="el-icon-phone-outline"></i>
                  020-89895456
                  18819806555 余小姐
                </el-col>
              </el-row>
              <img src="../static/img/footer_ewei.png" alt="">
            </el-col>
          </el-row>
        </div>
        <div class="footer_bm">
          <p>Copyright © 2008-2018 广州星辰热能股份有限公司 粤ICP备14011461号-1</p>
        </div>
      </footer>
    </div>
    <div class="returnTop"><i class="el-icon-arrow-up"></i></div>
  </div>
</template>

<script>
  import api from './api.js';
  import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
  import {WOW} from 'wowjs';

  export default {
    computed: {},
    data() {
      return {
        activeIndex: '1',
        restaurants: [],
        state4: '',
        timeout: null,
        tradeList: [],
        status: false,
      }
    },
    methods: {
      ...mapMutations(['getName', 'getSeekResult']),
      handleSelect1(key, keyPath) {

      },
      /*======搜索=======*/
      focusEvent() {
        this.status = true;
      },
      blurEvent() {
        this.status = false;
      },
      seekMsg() {
        $(document).keyup((event) => {
          if (event.keyCode == 13 && this.status && this.state4 != '') {
            this.$router.push({path: '/seek', query: {keywords: this.state4}});
            this.$axios({
              method: 'get',
              url: api + '/search/on-site',
              params: {
                keyword: this.state4,
              },
            }).then((xhr) => {
              this.getSeekResult(xhr.data);
              this.state4 = '';
              this.moveSeekTop(0.5);
            }).catch((err) => {
              console.log(err);
            })
          }
        });
      },        //发送搜索请求
      moveSeek() {
        var _this = this;
        var _element = document.querySelector('#app_C'),
          _startPos = 0,
          _transitionHeight = 0;
        _element.addEventListener('touchstart', function (e) {
          _startPos = e.touches[0].pageY;
          _element.style.position = 'relative';
          _element.style.transition = 'transform 0s';
        }, false);
        _element.addEventListener('touchmove', function (e) {
          var top = $('#app').offset().top - $(window).scrollTop();
          _transitionHeight = e.touches[0].pageY - _startPos;
          if (_transitionHeight > 50 && top >= 0) {
            _element.style.transform = 'translateY(' + 60 + 'px)';
            _element.style.transition = 'transform 0.5s ';
          } else {
            _this.moveSeekTop(0);
          }
          ;

        }, false);
        /*   _element.addEventListener('touchend', function (e) {
             // _element.style.transition = 'transform 0.5s ease 3s';
             //_element.style.transform = 'translateY(0px)';
             // todo...
           }, false);*/
      },      //移动端显示搜索框
      moveSeekTop(s) {
        var app = document.querySelector('#app_C');
        app.style.transition = 'transform ' + s + 's';
        app.style.transform = 'translateY(0px)';
      },   //隐藏搜索框
      /*=====导航下拉动画，返回顶部，移动pc导航=====*/
      titleMove() {
        var _this = this;
        //顶部导航
        $('.el-menu-item').mouseenter(function () {
          var index = $(this).attr('md');
          if (index == 'undefined') return;
          $('.vice').eq(index).stop(true, false).slideDown(300).mouseenter(function () {
            $('.vice').eq(index).stop(true, false).slideDown(300);
          });

        });
        $('.el-menu-item').mouseleave(function () {
          $('.vice').stop(true, false).slideUp(300);
        })
        $('.vice').mouseleave(function () {
          $('.vice').stop(true, false).slideUp(300);
        });

        //手机端导航
        $('#nav p').click(function () {
          $('body').toggleClass('bodyActihve');
          _this.moveSeekTop(0);
        });
        $('.navList .lis').click(function () {
          $(this).children('.navListIn').toggle(200);
        });
        $(".navList .navListIn li").click(function (event) {
          event.stopPropagation();
        });//阻止冒泡

      },
      returnTop() {
        if ($(window).scrollTop() < 100) {
          $('.returnTop').hide();
        }
        $(window).scroll(function () {
          if ($(this).scrollTop() > 100) {
            $('.returnTop').stop(true, false).fadeIn();
          } else {
            $('.returnTop').stop(true, false).fadeOut();
          }
        });
        $('.returnTop').bind('click', () => {
          this.moveSeekTop(0);
          $('html ,body').animate({scrollTop: 0}, 300);
          return false;
        });
      },
      restore() {
        $('body').removeClass('bodyActihve');
        $('.navListIn').css({display: 'none'});
      },

      tradeData() {
        this.$axios({
          method: 'get',
          url: api + '/industry/list', //行业列表
          params: {},
        }).then(xhr => {
          this.tradeList = xhr.data.data;
        }).catch(err => {
          console.log(err);
        })
      }, //行业title
      visit() {
        this.$axios({
          method: 'get',
          url: api + '/login/web_visits_count', //行业列表
          params: {},
        }).then(xhr => {
          console.log('访问成功');
        }).catch(err => {
          console.log(err);
        });
      }, //访问次数;
    },
    created() {
      this.tradeData();
      this.visit();
    },
    mounted() {
      this.titleMove();     //导航栏下拉动画
      this.returnTop();     //返回顶部
      this.seekMsg();       //  搜索
      this.moveSeek();

      var cnzz_protocol = (("https:" == document.location.protocol) ? " https://" : " http://");
      document.write(unescape("%3Cspan id='cnzz_stat_icon_1274194333'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s13.cnzz.com/z_stat.php%3Fid%3D1274194333%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));
      $('.footer_bm p').append($('#cnzz_stat_icon_1274194333'));


    },
    watch: {
      $route(to, from) {
        // console.log(this.$route);
        var Path = this.$route.path;
        if (Path != '/culture' && Path != '/cultureInfo') {
          localStorage.removeItem('culturePage');
        }
        if (Path != '/Product' && Path != '/Product/ProductInfo') {
          localStorage.removeItem('productPage');
        }
      },

    },

  }
</script>

<style lang="less" type="text/less">
  .bodyActihve {
    transform: translateX(-55%) !important;
    display: block;
  }

  #app {
    #app_C::before {
      content: '';
      width: 100%;
      height: auto;
      display: inline;
      background-color: red;
    }
    header {
      padding-bottom: 5px;
      position: relative;
      box-sizing: border-box;
      z-index: 998;
      .logo {
        height: 80px;
        margin-top: 15px;
      }
      /*导航*/
      .el-menu {
        float: right;
        z-index: 5;
        margin: 20px auto !important;
        > .el-menu-item.is-active {
          color: #409EFF !important;
        }
        > .el-menu-item {
          color: #000;
          padding: 0 10px;
        }
        > .el-menu-item:hover {
          color: #409EFF;
        }
      }
      a {
        font-size: 16px;
        display: inline-block;
      }
      .el-input__inner {
        width: 200px;
        border-radius: 20px;
      }
      .seek {
        width: auto;
        margin-top: 10px;
      }
      #nav {
        p {
          width: 50px;
          height: 50px;
          display: none;
          cursor: pointer;
          span {
            display: block;
            width: 30px;
            height: 2px;
            margin: 10px auto;
            background-color: #409EFF;
          }
        }
        .phoneNav {
          position: fixed;
          right: -55%;
          top: 0;
          z-index: 999;
          width: 55%;
          height: 100%;
          overflow: hidden;
          padding: 50px 0 0 40px;
          border-left: 5px solid #0065b3;
          background: #fff;
          .navList {
            li {
              line-height: 3;
              a {
                display: inline-block;
                width: 100%;
                font-size: 16px;
                color: #666;
                border-bottom: 1px solid #CCC;
              }
              .navListIn {
                display: none;
                ul {
                  padding-left: 20px;
                  li {
                    a {
                      border-bottom: 1px solid #eeeeee;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .vice {
      box-sizing: border-box;
      position: absolute;
      top: 58px;
      left: 0px;
      background: rgba(255, 255, 255, .8);
      border: 1px solid #dedede;
      border-top: 2px solid #409EFF;

      color: #000;
      padding: 10px 0;
      z-index: 3;
      display: none;
      ul {
        li {
          min-width: 104px;
          font-size: 14px;
          line-height: 1;
          padding: 10px 20px;
          box-sizing: border-box;
          a {
            font-size: 14px;
          }
        }
        li:hover {
          color: #409EFF;
        }
      }
    }
    footer {
      background-color: #2c2d31;
      color: #FFF;
      .footer_top {
        padding: 55px 0px;
        flex-wrap: wrap;
        .item {
          margin-bottom: 35px;
          h2 {
            line-height: 35px;
            font-size: 18px;
            margin-bottom: 10px
          }
          i {
            font-size: 20px;
          }
          .el-col {
            font-size: 14px;
            line-height: 40px;
            opacity: .6;
            .el-col {
              opacity: 1;
              a {
                color: #EEE;
              }

            }
            .el-col a:hover {
              color: #f8f703;
              cursor: pointer;
            }
          }
        }
        .item:last-child {
          position: relative;
          img {
            width: 80px;
            height: 80px;
            position: absolute;
            left: 180px;
            top: 10px;
          }
        }
      }
      .footer_bm {
        text-align: center;
        background: #1a1b1f;
        p {
          // line-height: 5;
          font-size: 14px;
          display: inline-block;
          margin: 30px 5px;
        }
      }
    }
    .returnTop {
      opacity: 0.8  !important;
      position: fixed;
      bottom: 50px;
      right: 25px;
      cursor: pointer;
      display: none;
      background-color: #409EFF;
      i {
        color: #FFF;
        font-size: 35px;
        border: 1px solid #409EFF;
      }
    }
    .returnTop:hover{
      opacity: 1!important;

    }
    .el-tabs__nav-wrap::after {
      height: 0px;
      top: 0;
      width: 500%;
    }
    .el-tabs__nav div {
      top: 0;
    }
    .el-menu&#45;&#45;horizontal {
      border: none
    }
    /*===移动端搜索===*/
    .moveSeek {
      position: absolute;
      top: -50px;
      width: 80%;
      margin-left: 10%;
      margin-top: 10px;
    }
    .seek {
      .el-input__inner {
        width: 100%;
        border-radius: 20px;
      }
    }
    /*公共*/
    .ta-r {
      text-align: right;
      line-height: 60px;
      font-size: 12px;
      color: #999;
    }
    .wrapper {
      max-width: 1200px;
      margin: 0 auto;
    }
    [v-cloak] {
      display: none;
    }
    .hint {
      text-align: center;
      height: 200px;
      line-height: 200px;
      font-size: 16px;
      color: #666;
    }
    .cTitle { //内容标题
      display: inline-block;
      font-size: 24px;
      padding: 50px 0 10px;
      border-bottom: 3px solid #003365;
    }
    .domain-public { /*服务领域*/
      .content {
        .title {
          text-align: center;
          font-size: 26px;
          margin: 50px auto;
          color: #003365;
        }
        .box {
          margin-bottom: 100px;
          h2 {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            display: inline-block;
            font-size: 18px;
            color: #FFF;
            border: 1px solid #003466;
            background-color: #003466;
          }
          .text {
            margin: 20px 0;
            p {
              line-height: 1.5;
              color: #003466;
            }
            ul {
              padding: 5px 5px 5px 35px;
              li {
                line-height: 1.5;
                color: #003466;
                list-style: disc;
              }
            }
            .dot {
              li {
                list-style: none;
              }
            }
            h3 {
              color: #003466;
              font-weight: bold;
              font-size: 18px;
              margin-bottom: 10px;
            }
            .bg {
              background-color: #f5fafe;
            }
            img {
              width: 100%;
            }
            .terrace_box {
              margin-top: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              .terrace_text {
                width: 20px;
                height: 150px;
                float: left;
                border: 3px solid #003466;
                border-radius: 7px;
                text-align: center;
                padding: 0px 5px;
                margin: 0 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                p {
                  line-height: 1;
                }
              }
            }
          }

        }
        .mb {
          margin-bottom: 40px;
        }
      }
    }
    .back { //返回上一页
      margin: 30px 0;
      p, a {
        color: #666;
        cursor: pointer;
      }
      p:hover, a:hover {
        color: #409eff;
      }
    }
  }

  @media only screen and (max-width: 992px) {
    #app {
      header {
        #el-menu1 {
          display: none;
        }
        #nav {
          float: right;
          p {
            display: block;
            padding-top: 22px;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 992px) {
    body {
      transform: translateX(0%) !important;
      display: inline;
    }

    /* .bodyActihve{
       transform: translateX(0%);
     }*/
  }

  @media (max-width: 1400px) {
    .wrapper {
      padding: 0 10px;
    }
  }

  @media (max-width: 480px) {
    #app {
      header {
        margin: 0;
        .logo {
          height: 60px;
          margin-top: 15px;
        }
      }
    }
  }
</style>
-->

<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
    name: 'App',
    mounted() {
      var cnzz_protocol = (("https:" == document.location.protocol) ? " https://" : " http://");
      document.write(unescape("%3Cspan id='cnzz_stat_icon_1274194333'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s13.cnzz.com/z_stat.php%3Fid%3D1274194333%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));

    }
  }
</script>

<style lang="less" type="text/less">
  .el-loading-parent--hidden {
    overflow: visible !important;
  }

  html, body {
    height: 100%;
  }

  #app {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue